<!-- 德育宠物形象管理：宠物定义 + 等级×状态图片矩阵。最后更新：2026-10-07 -->
<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right pet-images-page">
      <div class="page-head">
        <p class="dp-dept-hint">
          <span class="dp-dept-hint__label">当前学校</span>
          <span class="dp-dept-hint__value">{{ schoolName || '未选择' }}</span>
        </p>
        <div class="filter-bar">
          <el-input v-model="keyword" size="small" clearable placeholder="搜索宠物名称" prefix-icon="el-icon-search" class="filter-bar__search" @input="page.currentPage = 1" />
          <el-radio-group v-model="statusFilter" size="small" @change="page.currentPage = 1">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="on">上架</el-radio-button>
            <el-radio-button label="off">下架</el-radio-button>
            <el-radio-button label="incomplete">图片未配齐</el-radio-button>
          </el-radio-group>
          <el-button size="small" icon="el-icon-refresh" :disabled="!schoolId" @click="load">刷新</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" :disabled="!schoolId" @click="handleAdd">新增宠物</el-button>
        </div>
      </div>

      <el-alert
        class="mood-tip"
        type="info"
        :closable="false"
        show-icon
        title="每个等级需配置 平稳 / 活力 / 调整 三种状态；活力或调整缺图时自动回退为平稳图。形象图用于家长端成长详情，头像用于学生评价列表。" />

      <div class="grid-host" v-loading="loading">
        <div v-if="!schoolId" class="empty-state">
          <i class="el-icon-school"></i>
          <span>请先在顶部切换到具体学校</span>
        </div>
        <div v-else-if="!pagedList.length" class="empty-state">
          <i class="el-icon-picture-outline"></i>
          <span>{{ list.length ? '没有符合条件的宠物' : '还没有宠物，点击右上角「新增宠物」开始配置' }}</span>
        </div>
        <div v-else class="pet-grid">
          <article v-for="pet in pagedList" :key="pet.petId" class="pet-card" :class="{ 'is-off': pet.status !== 1 }">
            <div class="pet-card__cover" @click="openMatrix(pet)">
              <img v-if="pet.coverUrl || firstImage(pet)" :src="resolveImageSrc(pet.coverUrl || firstImage(pet))" :alt="pet.petName" />
              <div v-else class="pet-card__placeholder"><i class="el-icon-picture-outline"></i><span>暂无封面</span></div>
              <span :class="['pet-card__status', pet.status === 1 ? 'is-on' : 'is-off']">{{ pet.status === 1 ? '上架中' : '已下架' }}</span>
            </div>
            <div class="pet-card__body">
              <div class="pet-card__title">
                <span class="pet-card__name" :title="pet.petName">{{ pet.petName }}</span>
                <span class="pet-card__sort">排序 {{ pet.sort }}</span>
              </div>
              <p class="pet-card__desc" :title="pet.description">{{ pet.description || '暂无简介' }}</p>
              <div class="pet-card__progress">
                <div class="progress-label">
                  <span>图片配置</span>
                  <span :class="{ 'is-done': pet.imageCount >= pet.requiredImageCount }">{{ pet.imageCount }} / {{ pet.requiredImageCount }}</span>
                </div>
                <div class="progress-bar"><span :style="{ width: imagePercent(pet) + '%' }" :class="{ 'is-done': pet.imageCount >= pet.requiredImageCount }"></span></div>
              </div>
              <div class="pet-card__meta">
                <span><i class="el-icon-user"></i>{{ pet.studentCount || 0 }} 名学生领取</span>
                <span>{{ pet.acquireType === 0 ? '免费领取' : '积分兑换' }}</span>
              </div>
            </div>
            <div class="pet-card__actions">
              <button type="button" class="card-action card-action--primary" @click="openMatrix(pet)"><i class="el-icon-picture"></i>管理图片矩阵</button>
              <button type="button" class="card-action" @click="openPreview(pet)"><i class="el-icon-view"></i>预览</button>
              <button type="button" class="card-action" @click="openEdit(pet)"><i class="el-icon-edit"></i>编辑信息</button>
              <button type="button" :class="['card-action', pet.status === 1 ? 'is-danger' : 'is-success']" @click="toggleStatus(pet)">
                <i :class="pet.status === 1 ? 'el-icon-bottom' : 'el-icon-top'"></i>{{ pet.status === 1 ? '下架' : '上架' }}
              </button>
              <button type="button" class="card-action is-danger" @click="removePet(pet)"><i class="el-icon-delete"></i>删除</button>
            </div>
          </article>
        </div>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="page.currentPage"
          :page-size="page.pageSize"
          :total="filteredList.length"
          @current-change="val => (page.currentPage = val)" />
      </div>

      <!-- 新增 / 编辑宠物 -->
      <el-dialog :title="editForm.id ? '编辑宠物' : '新增宠物'" :visible.sync="editVisible" width="560px" :close-on-click-modal="false">
        <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="88px">
          <el-form-item label="宠物名称" prop="petName">
            <el-input v-model="editForm.petName" maxlength="20" show-word-limit placeholder="如：小火龙" />
          </el-form-item>
          <el-form-item label="封面图">
            <div class="cover-field">
              <div class="upload-tile upload-tile--lg" :class="{ 'has-image': editForm.coverUrl }">
                <img v-if="editForm.coverUrl" :src="resolveImageSrc(editForm.coverUrl)" alt="封面" />
                <el-upload v-else action="#" :show-file-list="false" accept="image/*" :http-request="options => uploadField(editForm, 'coverUrl', options)">
                  <div class="upload-tile__empty"><i class="el-icon-plus"></i><span>上传封面</span></div>
                </el-upload>
                <div v-if="editForm.coverUrl" class="upload-tile__mask">
                  <i class="el-icon-delete" title="删除" @click="editForm.coverUrl = ''"></i>
                </div>
              </div>
              <span class="field-tip">未上传时卡片使用第 1 级平稳形象图作为封面。</span>
            </div>
          </el-form-item>
          <el-form-item label="宠物简介">
            <el-input v-model="editForm.description" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="展示给家长的宠物介绍" />
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editForm.sort" :min="0" :max="9999" controls-position="right" />
            <span class="field-tip field-tip--inline">数字越小越靠前</span>
          </el-form-item>
          <el-form-item label="获取方式">
            <el-tag size="small" type="success">免费领取</el-tag>
            <span class="field-tip field-tip--inline">积分兑换后续开放</span>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="editVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="submitEdit">保存</el-button>
        </span>
      </el-dialog>

      <!-- 图片矩阵 -->
      <el-dialog
        :visible.sync="matrixVisible"
        width="820px"
        top="4vh"
        custom-class="matrix-dialog"
        :close-on-click-modal="false">
        <div slot="title" class="matrix-title">
          <span class="matrix-title__name">{{ current ? current.petName : '' }} · 图片矩阵</span>
          <span class="matrix-title__count">
            状态 {{ matrixFilledCount }}/{{ matrix.length * moods.length }} ·
            图片 {{ matrixFileCount }}/{{ matrix.length * (moods.length + 1) }}
          </span>
        </div>
        <div class="matrix-legend">
          <span v-for="mood in moods" :key="mood.code" class="legend-item">
            <i :style="{ background: mood.color }"></i>{{ mood.name }}<small>{{ mood.desc }}</small>
          </span>
          <span class="legend-note">
            <i class="el-icon-info"></i>当天状态始终按当天净分（加分与扣分相抵）判断，与学期分统计方式无关
          </span>
        </div>
        <div v-if="matrixMissingStable.length" class="matrix-warning">
          <i class="el-icon-warning-outline"></i>
          还有 {{ matrixMissingStable.length }} 个等级缺少平稳图（形象图或头像），完整前不能上架。
        </div>
        <div class="matrix-scroll">
          <table class="matrix-table">
            <thead>
              <tr>
                <th class="matrix-table__level">等级</th>
                <th v-for="mood in moods" :key="mood.code" :style="{ borderTopColor: mood.color }">{{ mood.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in matrix" :key="row.levelIndex">
                <td class="matrix-table__level">
                  <div class="level-name">Lv.{{ row.levelIndex }}</div>
                  <div class="level-sub">{{ row.levelName }}</div>
                </td>
                <td v-for="mood in moods" :key="mood.code">
                  <div class="cell-pair">
                    <div v-for="field in imageFields" v-if="field.key !== 'avatarUrl' || mood.code === 0" :key="field.key" class="cell-item">
                      <div class="upload-tile" :class="{ 'has-image': row.images[mood.code][field.key], 'is-avatar': field.key === 'avatarUrl' }">
                        <el-image
                          v-if="row.images[mood.code][field.key]"
                          :src="resolveImageSrc(row.images[mood.code][field.key])"
                          class="is-zoomable"
                          fit="cover"
                          @click.native="openMatrixViewer(row.images[mood.code][field.key])" />
                        <el-upload
                          v-else
                          action="#"
                          accept="image/*"
                          :show-file-list="false"
                          :http-request="options => uploadCell(row.images[mood.code], field.key, options)">
                          <div class="upload-tile__empty">
                            <i :class="cellUploading[cellKey(row, mood, field)] ? 'el-icon-loading' : 'el-icon-plus'"></i>
                          </div>
                        </el-upload>
                        <div v-if="row.images[mood.code][field.key]" class="upload-tile__mask upload-tile__mask--corner">
                          <i class="el-icon-zoom-in" title="放大查看" @click="openMatrixViewer(row.images[mood.code][field.key])"></i>
                          <el-upload
                            action="#"
                            accept="image/*"
                            :show-file-list="false"
                            :http-request="options => uploadCell(row.images[mood.code], field.key, options)">
                            <i class="el-icon-refresh" title="替换"></i>
                          </el-upload>
                          <i class="el-icon-delete" title="删除" @click="clearCell(row.images[mood.code], field.key)"></i>
                        </div>
                      </div>
                      <span class="cell-label">{{ field.label }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span slot="footer">
          <el-button @click="matrixVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="saveMatrix">保存图片</el-button>
        </span>
      </el-dialog>

      <el-image-viewer
        v-if="matrixViewer.visible"
        :url-list="matrixImageList"
        :initial-index="matrixViewer.index"
        :on-close="closeMatrixViewer"
        append-to-body />

      <!-- 各等级效果预览 -->
      <el-dialog
        :title="preview.pet ? `效果预览 · ${preview.pet.petName}` : '效果预览'"
        :visible.sync="previewVisible"
        width="1000px"
        append-to-body
        @close="stopAutoPlay">
        <div v-if="preview.pet" class="preview">
          <div class="preview__toolbar">
            <el-radio-group v-model="preview.mood" size="small">
              <el-radio-button v-for="mood in moods" :key="mood.code" :label="mood.code">{{ mood.name }}</el-radio-button>
            </el-radio-group>
            <div class="preview__nav">
              <el-button size="small" icon="el-icon-arrow-left" :disabled="preview.level <= 1" @click="stepLevel(-1)">上一级</el-button>
              <span class="preview__level">Lv.{{ preview.level }} · {{ levelName(preview.level) }}</span>
              <el-button size="small" :disabled="preview.level >= levels.length" @click="stepLevel(1)">下一级<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button size="small" :type="preview.timer ? 'warning' : 'default'" :icon="preview.timer ? 'el-icon-video-pause' : 'el-icon-video-play'" @click="toggleAutoPlay">
                {{ preview.timer ? '暂停' : '自动播放' }}
              </el-button>
            </div>
          </div>

          <div class="preview__stage">
            <div class="stage-main">
              <img v-if="previewCell.imageUrl" :src="resolveImageSrc(previewCell.imageUrl)" alt="形象图" />
              <div v-else class="stage-empty"><i class="el-icon-picture-outline"></i>缺少平稳形象图</div>
              <span class="stage-label">形象图（成长详情）</span>
            </div>
            <div class="stage-side">
              <div class="stage-avatar">
                <img v-if="previewCell.avatarUrl" :src="resolveImageSrc(previewCell.avatarUrl)" alt="头像" />
                <i v-else class="el-icon-picture-outline"></i>
              </div>
              <span class="stage-label">头像（学生评价）</span>
              <div v-if="previewCell.imageFallback || previewCell.avatarFallback" class="stage-tip">
                <i class="el-icon-info"></i>
                未上传「{{ moodName(preview.mood) }}」{{ previewCell.imageFallback && previewCell.avatarFallback ? '形象图和头像' : previewCell.imageFallback ? '形象图' : '头像' }}，展示时使用平稳图
              </div>
              <div v-else-if="previewCell.imageUrl && previewCell.avatarUrl" class="stage-tip is-ok">
                <i class="el-icon-circle-check"></i>该等级「{{ moodName(preview.mood) }}」图片已配齐
              </div>
            </div>
          </div>

          <div class="filmstrip">
            <button
              v-for="level in levels"
              :key="level.levelIndex"
              type="button"
              :class="['film', { 'is-active': preview.level === level.levelIndex }]"
              @click="selectLevel(level.levelIndex)">
              <span class="film__img">
                <img v-if="cellOf(level.levelIndex, preview.mood).imageUrl" :src="resolveImageSrc(cellOf(level.levelIndex, preview.mood).imageUrl)" alt="" />
                <i v-else class="el-icon-picture-outline"></i>
              </span>
              <span class="film__label">Lv.{{ level.levelIndex }}</span>
              <span v-if="cellOf(level.levelIndex, preview.mood).imageFallback" class="film__dot" title="使用平稳图"></span>
            </button>
          </div>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '@/components/DepartmentPane.vue'
import { getPetConfig, getPetList, savePet, setPetStatus, deletePet } from '@/api/modules/pet'
import { resolveImageSrc, uploadPic, stripOssPresignParams } from '@/utils/ossMediaUpload'
import { resolveDisplayMediaUrl } from '@/utils/mediaUrl'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { treeNodeDeptId } from '@/utils/deptCascaderProps'

export default {
  name: 'PetImages',
  components: { DepartmentPane, ElImageViewer },
  data () {
    return {
      schoolId: 0,
      schoolName: '',
      loading: false,
      saving: false,
      list: [],
      keyword: '',
      statusFilter: 'all',
      page: { currentPage: 1, pageSize: 12 },
      levels: [],
      editVisible: false,
      editForm: this.buildDefaultForm(),
      editRules: {
        petName: [{ required: true, message: '请输入宠物名称', trigger: 'blur' }]
      },
      matrixVisible: false,
      previewVisible: false,
      preview: { pet: null, level: 1, mood: 0, timer: null },
      current: null,
      matrix: [],
      cellUploading: {},
      matrixViewer: { visible: false, index: 0 },
      moods: [
        { code: 0, name: '平稳', desc: '当天净分为 0', color: '#2563eb' },
        { code: 1, name: '活力', desc: '当天净分大于 0', color: '#16a34a' },
        { code: 2, name: '调整', desc: '当天净分小于 0', color: '#f59e0b' }
      ],
      imageFields: [
        { key: 'imageUrl', label: '形象图' },
        { key: 'avatarUrl', label: '头像' }
      ]
    }
  },
  computed: {
    filteredList () {
      const kw = (this.keyword || '').trim()
      return this.list.filter(item => {
        if (kw && String(item.petName || '').indexOf(kw) === -1) return false
        if (this.statusFilter === 'on') return item.status === 1
        if (this.statusFilter === 'off') return item.status !== 1
        if (this.statusFilter === 'incomplete') return item.imageCount < item.requiredImageCount
        return true
      })
    },
    pagedList () {
      const start = (this.page.currentPage - 1) * this.page.pageSize
      return this.filteredList.slice(start, start + this.page.pageSize)
    },
    matrixFilledCount () {
      return this.matrix.reduce((sum, row) => sum + this.moods.filter(m => row.images[m.code].imageUrl).length, 0)
    },
    matrixFileCount () {
      return this.matrix.reduce((sum, row) => {
        const imageCount = this.moods.filter(mood => row.images[mood.code].imageUrl).length
        return sum + imageCount + (row.images[0].avatarUrl ? 1 : 0)
      }, 0)
    },
    /** 矩阵内已上传图片的原始地址，按等级 → 状态 → 形象图/头像顺序排列 */
    matrixRawImageList () {
      const list = []
      this.matrix.forEach(row => {
        this.moods.forEach(mood => {
          const image = row.images[mood.code]
          if (image.imageUrl) list.push(image.imageUrl)
          if (mood.code === 0 && image.avatarUrl) list.push(image.avatarUrl)
        })
      })
      return list
    },
    matrixImageList () {
      return this.matrixRawImageList.map(url => resolveImageSrc(url))
    },
    matrixMissingStable () {
      return this.matrix.filter(row => !row.images[0].imageUrl || !row.images[0].avatarUrl)
    },
    previewCell () {
      return this.cellOf(this.preview.level, this.preview.mood)
    }
  },
  beforeDestroy () {
    this.stopAutoPlay()
  },
  methods: {
    buildDefaultForm () {
      return { id: 0, petName: '', description: '', coverUrl: '', sort: 0, acquireType: 0, pricePoints: null, minLevel: null, limitStock: null }
    },
    resolveImageSrc (url) {
      return resolveImageSrc(url)
    },
    /** 私有 Bucket 上传后换成预签名地址展示，保存时再剥离签名。创建于 2026-10-10 */
    async toDisplayUrl (url) {
      try {
        return await resolveDisplayMediaUrl(url, this.schoolId) || url
      } catch (e) {
        return url
      }
    },
    /** 放大查看矩阵图片，可左右切换浏览整套形象。创建于 2026-10-08 */
    openMatrixViewer (url) {
      const index = this.matrixRawImageList.indexOf(url)
      this.matrixViewer = { visible: true, index: index < 0 ? 0 : index }
    },
    closeMatrixViewer () {
      this.matrixViewer.visible = false
    },
    /** 学校切换（顶栏驱动） */
    treeNodeClick (data) {
      this.schoolId = treeNodeDeptId(data)
      this.schoolName = (data && data.label) || this.$store.state.activeSchoolName || ''
      this.page.currentPage = 1
      this.list = []
      if (this.schoolId) this.load()
    },
    async load () {
      if (!this.schoolId) return
      this.loading = true
      try {
        const [listRes, configRes] = await Promise.all([
          getPetList({ schoolId: this.schoolId }),
          getPetConfig({ schoolId: this.schoolId })
        ])
        this.list = (listRes.data && listRes.data.response) || []
        const config = configRes.data && configRes.data.response
        this.levels = config && config.levels && config.levels.length
          ? config.levels
          : Array.from({ length: 10 }, (_, i) => ({ levelIndex: i + 1, levelName: `第${i + 1}级` }))
        const maxPage = Math.max(1, Math.ceil(this.filteredList.length / this.page.pageSize))
        if (this.page.currentPage > maxPage) this.page.currentPage = maxPage
      } finally {
        this.loading = false
      }
    },
    firstImage (pet) {
      const images = pet.images || []
      const stable = images.filter(x => x.mood === 0 && x.imageUrl).sort((a, b) => a.levelIndex - b.levelIndex)
      return stable.length ? stable[0].imageUrl : ''
    },
    imagePercent (pet) {
      if (!pet.requiredImageCount) return 0
      return Math.min(100, Math.round(pet.imageCount / pet.requiredImageCount * 100))
    },
    handleAdd () {
      this.editForm = this.buildDefaultForm()
      this.editForm.sort = this.list.length ? Math.max(...this.list.map(x => x.sort || 0)) + 1 : 0
      this.editVisible = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
    },
    openEdit (pet) {
      this.editForm = {
        id: pet.petId,
        petName: pet.petName,
        description: pet.description,
        coverUrl: pet.coverUrl,
        sort: pet.sort,
        acquireType: pet.acquireType,
        pricePoints: pet.pricePoints,
        minLevel: pet.minLevel,
        limitStock: pet.limitStock
      }
      this.editVisible = true
    },
    async uploadField (target, field, options) {
      try {
        const result = await uploadPic(options.file, this, 'PetImage')
        this.$set(target, field, await this.toDisplayUrl(result.url))
      } catch (e) {
        this.$message.error(e.message || '图片上传失败')
      }
    },
    /** 保存宠物基础信息；编辑时不传 images，后端保持原图片矩阵不变 */
    submitEdit () {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const res = await savePet(Object.assign({}, this.editForm, {
            schoolId: this.schoolId,
            coverUrl: stripOssPresignParams(this.editForm.coverUrl),
            images: null
          }))
          if (res.data && res.data.success) {
            this.$message.success('保存成功')
            this.editVisible = false
            this.load()
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        } finally {
          this.saving = false
        }
      })
    },
    async toggleStatus (pet) {
      const target = pet.status === 1 ? 0 : 1
      if (target === 0) {
        try {
          await this.$confirm(`下架后家长端将无法再选择「${pet.petName}」，已领取的学生不受影响。确认下架？`, '提示', { type: 'warning' })
        } catch (e) {
          return
        }
      }
      const res = await setPetStatus({ schoolId: this.schoolId, petId: pet.petId, status: target })
      if (res.data && res.data.success) {
        this.$message.success(target === 1 ? '已上架' : '已下架')
        pet.status = target
      } else {
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    },
    /** 删除宠物：仍有学生使用时由后端拒绝 */
    async removePet (pet) {
      if (pet.studentCount > 0) {
        return this.$message.warning(`有 ${pet.studentCount} 名学生正在使用「${pet.petName}」，不能删除，可改为下架`)
      }
      try {
        await this.$confirm(`确认删除「${pet.petName}」？删除后图片矩阵一并不可用，且无法恢复。`, '删除宠物', { type: 'warning', confirmButtonText: '删除' })
      } catch (e) {
        return
      }
      const res = await deletePet({ schoolId: this.schoolId, petId: pet.petId })
      if (res.data && res.data.success) {
        this.$message.success('已删除')
        this.load()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    /** 打开各等级效果预览，默认第 1 级平稳 */
    openPreview (pet) {
      this.stopAutoPlay()
      this.preview = { pet, level: 1, mood: 0, timer: null }
      this.previewVisible = true
    },
    /** 取某等级某状态的图片；缺失时按规则回退到同等级平稳图 */
    cellOf (levelIndex, mood) {
      const images = (this.preview.pet && this.preview.pet.images) || []
      const exact = images.find(x => x.levelIndex === levelIndex && x.mood === mood) || {}
      const stable = images.find(x => x.levelIndex === levelIndex && x.mood === 0) || {}
      return {
        imageUrl: exact.imageUrl || stable.imageUrl || '',
        avatarUrl: exact.avatarUrl || stable.avatarUrl || '',
        imageFallback: mood !== 0 && !exact.imageUrl && !!stable.imageUrl,
        avatarFallback: false
      }
    },
    levelName (levelIndex) {
      const level = this.levels.find(x => x.levelIndex === levelIndex)
      return level ? level.levelName : ''
    },
    moodName (code) {
      const mood = this.moods.find(x => x.code === code)
      return mood ? mood.name : ''
    },
    stepLevel (delta) {
      this.selectLevel(Math.min(this.levels.length, Math.max(1, this.preview.level + delta)))
    },
    selectLevel (levelIndex) {
      this.preview.level = levelIndex
    },
    /** 自动从当前等级逐级播放，到最高级后回到第 1 级 */
    toggleAutoPlay () {
      if (this.preview.timer) return this.stopAutoPlay()
      this.preview.timer = setInterval(() => {
        this.preview.level = this.preview.level >= this.levels.length ? 1 : this.preview.level + 1
      }, 1200)
    },
    stopAutoPlay () {
      if (this.preview.timer) clearInterval(this.preview.timer)
      this.preview.timer = null
    },
    openMatrix (pet) {
      this.current = pet
      const oldImages = pet.images || []
      this.matrix = this.levels.map(level => {
        const images = {}
        this.moods.forEach(mood => {
          const old = oldImages.find(item => item.levelIndex === level.levelIndex && item.mood === mood.code)
          images[mood.code] = old
            ? Object.assign({}, old)
            : { levelIndex: level.levelIndex, mood: mood.code, imageUrl: '', avatarUrl: '' }
        })
        return { levelIndex: level.levelIndex, levelName: level.levelName, images }
      })
      this.cellUploading = {}
      this.matrixVisible = true
    },
    cellKey (row, mood, field) {
      return `${row.levelIndex}-${mood.code}-${field.key}`
    },
    async uploadCell (cell, field, options) {
      const key = `${cell.levelIndex}-${cell.mood}-${field}`
      this.$set(this.cellUploading, key, true)
      try {
        const result = await uploadPic(options.file, this, 'PetImage')
        this.$set(cell, field, await this.toDisplayUrl(result.url))
      } catch (e) {
        this.$message.error(e.message || '图片上传失败')
      } finally {
        this.$set(this.cellUploading, key, false)
      }
    },
    clearCell (cell, field) {
      this.$set(cell, field, '')
    },
    async saveMatrix () {
      const images = []
      this.matrix.forEach(row => {
        this.moods.forEach(mood => {
          const image = row.images[mood.code]
          if (image.imageUrl || (mood.code === 0 && image.avatarUrl)) {
            images.push({
              ...image,
              imageUrl: stripOssPresignParams(image.imageUrl),
              avatarUrl: mood.code === 0 ? stripOssPresignParams(image.avatarUrl) : ''
            })
          }
        })
      })
      const missingStable = this.matrix.filter(row => !row.images[0].imageUrl).map(row => row.levelIndex)
      if (missingStable.length) {
        try {
          await this.$confirm(`第 ${missingStable.join('、')} 级缺少平稳形象图，家长端在这些等级将无图可显示。仍要保存吗？`, '提示', { type: 'warning' })
        } catch (e) {
          return
        }
      }
      this.saving = true
      try {
        const pet = this.current
        const res = await savePet({
          id: pet.petId,
          schoolId: this.schoolId,
          petName: pet.petName,
          description: pet.description,
          coverUrl: stripOssPresignParams(pet.coverUrl),
          acquireType: pet.acquireType,
          pricePoints: pet.pricePoints,
          minLevel: pet.minLevel,
          limitStock: pet.limitStock,
          sort: pet.sort,
          images
        })
        if (res.data && res.data.success) {
          this.$message.success('保存成功')
          this.matrixVisible = false
          this.load()
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败')
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.pet-images-page { display: flex; flex-direction: column; min-height: 0; }
.page-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; margin-bottom: 10px; }
.page-head .dp-dept-hint { margin: 0; }
.filter-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.filter-bar__search { width: 200px; }
.mood-tip { margin-bottom: 12px; }

.grid-host { flex: 1; min-height: 0; overflow-y: auto; padding: 2px; }
.empty-state { height: 100%; min-height: 300px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; color: #64748b; }
.empty-state i { font-size: 40px; color: #94a3b8; }

.pet-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 18px; padding: 4px; }
.pet-card { display: flex; flex-direction: column; background: #fff; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease; }
.pet-card:hover { transform: translateY(-2px); border-color: #bfdbfe; box-shadow: 0 12px 28px rgba(15, 23, 42, .08); }
.pet-card.is-off .pet-card__cover img { filter: grayscale(.6); opacity: .75; }
.pet-card__cover { position: relative; height: 190px; background: radial-gradient(circle at 50% 15%, #dbeafe, #f8fafc 65%); cursor: pointer; }
.pet-card__cover img { width: 100%; height: 100%; object-fit: contain; display: block; }
.pet-card__placeholder { height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; color: #94a3b8; font-size: 12px; }
.pet-card__placeholder i { font-size: 30px; }
.pet-card__status { position: absolute; top: 10px; left: 10px; padding: 2px 8px; border-radius: 999px; font-size: 12px; font-weight: 500; }
.pet-card__status.is-on { background: #dcfce7; color: #15803d; }
.pet-card__status.is-off { background: #f1f5f9; color: #475569; }
.pet-card__body { padding: 16px 18px 14px; display: flex; flex-direction: column; gap: 10px; flex: 1; }
.pet-card__title { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.pet-card__name { font-size: 16px; font-weight: 650; color: #0f172a; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pet-card__sort { flex-shrink: 0; font-size: 12px; color: #64748b; }
.pet-card__desc { margin: 0; font-size: 12px; color: #475569; line-height: 1.5; height: 36px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.progress-label { display: flex; justify-content: space-between; font-size: 12px; color: #64748b; margin-bottom: 4px; }
.progress-label .is-done { color: #15803d; font-weight: 600; }
.progress-bar { height: 6px; border-radius: 999px; background: #f1f5f9; overflow: hidden; }
.progress-bar span { display: block; height: 100%; border-radius: 999px; background: #f59e0b; transition: width .25s ease; }
.progress-bar span.is-done { background: #16a34a; }
.pet-card__meta { display: flex; justify-content: space-between; font-size: 12px; color: #64748b; }
.pet-card__meta i { margin-right: 4px; }
.pet-card__actions { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; padding: 10px 12px 12px; border-top: 1px solid #f1f5f9; background: #fcfdff; }

.preview { display: flex; flex-direction: column; gap: 14px; }
.preview__toolbar { display: flex; align-items: center; justify-content: space-between; gap: 10px; flex-wrap: wrap; }
.preview__nav { display: flex; align-items: center; gap: 8px; }
.preview__level { min-width: 120px; text-align: center; font-size: 14px; font-weight: 600; color: #0f172a; }
.preview__stage { display: grid; grid-template-columns: minmax(0, 1fr) 260px; gap: 16px; }
.stage-main { position: relative; height: 360px; display: flex; align-items: center; justify-content: center; border-radius: 12px; background: linear-gradient(160deg, #eff6ff, #f8fafc); border: 1px solid #e2e8f0; overflow: hidden; }
.stage-main img { max-width: 92%; max-height: 88%; object-fit: contain; transition: opacity .25s ease; }
.stage-empty { display: flex; flex-direction: column; align-items: center; gap: 8px; color: #94a3b8; font-size: 13px; }
.stage-empty i { font-size: 36px; }
.stage-label { font-size: 12px; color: #64748b; }
.stage-main .stage-label { position: absolute; left: 12px; bottom: 10px; }
.stage-side { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 12px; border-radius: 12px; border: 1px solid #e2e8f0; background: #fff; }
.stage-avatar { width: 96px; height: 96px; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #f8fafc; border: 1px solid #e2e8f0; color: #94a3b8; font-size: 28px; }
.stage-avatar img { width: 100%; height: 100%; object-fit: cover; }
.stage-tip { margin-top: 8px; padding: 8px 10px; border-radius: 8px; background: #fffbeb; color: #b45309; font-size: 12px; line-height: 1.6; }
.stage-tip.is-ok { background: #f0fdf4; color: #15803d; }
.stage-tip i { margin-right: 4px; }
.filmstrip { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; }
.film { position: relative; flex: 1 0 80px; display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 6px; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; cursor: pointer; transition: border-color .2s ease, background-color .2s ease; }
.film:hover { border-color: #93c5fd; }
.film.is-active { border-color: #2563eb; background: #eff6ff; }
.film__img { width: 64px; height: 64px; display: flex; align-items: center; justify-content: center; border-radius: 6px; background: #f8fafc; overflow: hidden; color: #cbd5e1; font-size: 20px; }
.film__img img { width: 100%; height: 100%; object-fit: contain; }
.film__label { font-size: 12px; color: #475569; font-weight: 500; }
.film__dot { position: absolute; top: 5px; right: 5px; width: 8px; height: 8px; border-radius: 50%; background: #f59e0b; }
.card-action { display: inline-flex; align-items: center; justify-content: center; gap: 5px; min-width: 0; height: 32px; padding: 0 8px; border: 1px solid #e5e7eb; border-radius: 7px; background: #fff; color: #334155; font-size: 12px; white-space: nowrap; cursor: pointer; transition: background-color .2s ease, border-color .2s ease, color .2s ease; }
.card-action:first-child { grid-column: span 2; }
.card-action + .card-action { border-left: 1px solid #e5e7eb; }
.card-action--primary { border-color: #bfdbfe; background: #eff6ff; color: #1d4ed8; font-weight: 600; }
.card-action:hover { border-color: #93c5fd; background: #eff6ff; color: #1d4ed8; }
.card-action.is-danger { border-color: #fecaca; color: #dc2626; }
.card-action.is-danger:hover { border-color: #fca5a5; background: #fef2f2; color: #b91c1c; }
.card-action.is-success { border-color: #bbf7d0; color: #16a34a; }
.card-action.is-success:hover { border-color: #86efac; background: #f0fdf4; color: #15803d; }
.card-action:focus-visible { outline: 2px solid #2563eb; outline-offset: -2px; }

.field-tip { font-size: 12px; color: #64748b; line-height: 1.5; }
.field-tip--inline { margin-left: 10px; }
.cover-field { display: flex; align-items: flex-end; gap: 12px; }

.upload-tile { position: relative; width: 72px; height: 72px; border: 1px dashed #cbd5e1; border-radius: 8px; background: #f8fafc; overflow: hidden; transition: border-color .2s ease; }
.upload-tile:hover { border-color: #2563eb; }
.upload-tile.has-image { border-style: solid; border-color: #e2e8f0; background: #fff; }
.upload-tile.is-avatar { border-radius: 50%; }
.upload-tile--lg { width: 120px; height: 120px; }
.upload-tile img, .upload-tile .el-image { width: 100%; height: 100%; display: block; object-fit: cover; }
.upload-tile > div:not(.upload-tile__mask),
.upload-tile /deep/ .el-upload { display: block; width: 100%; height: 100%; }
.upload-tile__empty { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; color: #94a3b8; font-size: 12px; cursor: pointer; }
.upload-tile__empty i { font-size: 18px; }
.upload-tile__mask { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; gap: 12px; background: rgba(15, 23, 42, .5); color: #fff; font-size: 16px; opacity: 0; transition: opacity .2s ease; }
.upload-tile__mask i { cursor: pointer; }
.upload-tile .is-zoomable { cursor: zoom-in; }
.upload-tile:hover .upload-tile__mask { opacity: 1; }
.upload-tile__mask--corner { inset: auto 0 0 0; height: 26px; gap: 14px; font-size: 13px; }
.upload-tile__mask--corner /deep/ .el-upload { width: auto; height: auto; color: #fff; }
.upload-tile.is-avatar .upload-tile__mask--corner { height: 24px; }

.matrix-title { display: flex; align-items: baseline; gap: 12px; }
.matrix-title__name { font-size: 16px; font-weight: 600; color: #0f172a; }
.matrix-title__count { font-size: 12px; color: #64748b; }
.matrix-legend { display: flex; align-items: center; gap: 18px; flex-wrap: wrap; margin-bottom: 12px; font-size: 13px; color: #334155; }
.legend-note { margin-left: auto; font-size: 12px; color: #64748b; }
.legend-note i { margin-right: 4px; color: #94a3b8; }
.matrix-warning { margin-bottom: 10px; padding: 8px 10px; border-radius: 6px; background: #fffbeb; color: #b45309; font-size: 12px; }
.matrix-warning i { margin-right: 4px; }
.legend-item { display: inline-flex; align-items: center; gap: 6px; }
.legend-item i { width: 10px; height: 10px; border-radius: 50%; display: inline-block; }
.legend-item small { color: #64748b; font-size: 12px; }
.matrix-scroll { flex: 1 1 auto; min-height: 120px; overflow: auto; border: 1px solid #e2e8f0; border-radius: 10px; }
.matrix-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.matrix-table th { position: sticky; top: 0; z-index: 2; background: #f8fafc; padding: 10px 12px; font-size: 13px; font-weight: 600; color: #0f172a; text-align: left; border-top: 3px solid transparent; border-bottom: 1px solid #e2e8f0; }
.matrix-table td { padding: 10px 12px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
.matrix-table tbody tr:hover td { background: #fafcff; }
.matrix-table__level { width: 120px; position: sticky; left: 0; z-index: 1; background: #fff; border-right: 1px solid #f1f5f9; }
.matrix-table th.matrix-table__level { z-index: 3; background: #f8fafc; border-top-color: #cbd5e1; }
.level-name { font-size: 14px; font-weight: 600; color: #1d4ed8; }
.level-sub { font-size: 12px; color: #64748b; margin-top: 2px; }
.cell-pair { display: flex; justify-content: center; gap: 14px; }
.matrix-table th:not(.matrix-table__level) { text-align: center; }
.cell-item { display: flex; flex-direction: column; align-items: center; gap: 4px; }
.cell-label { font-size: 12px; color: #64748b; }
</style>

<style>
/* 弹窗按视口高度弹性分配：标题/说明/底部按钮按内容高度，表格吃剩余空间内滚，缩放窗口时按钮不被裁掉 */
.el-dialog.matrix-dialog { display: flex; flex-direction: column; max-width: 1280px; max-height: 92vh !important; margin-bottom: 0 !important; border-radius: 12px; }
.el-dialog.matrix-dialog > .el-dialog__header,
.el-dialog.matrix-dialog > .el-dialog__footer { flex-shrink: 0; }
.el-dialog.matrix-dialog > .el-dialog__body { display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; padding: 8px 20px 4px; max-height: none !important; overflow: hidden !important; }
.el-dialog.matrix-dialog .matrix-legend,
.el-dialog.matrix-dialog .matrix-warning { flex-shrink: 0; }
</style>
